import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';

import randomizeSpritePosition from '../lib/randomize-sprite-position';

import LibraryComponent from '../components/library/library.jsx';
import {
    loadScratchSprites,
    loadScratchSpriteTags,
    SCRATCH_SPRITE_PAGE_SIZE
} from '../lib/scratch-sprite-library';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect',
            'handleRequestQuery'
        ]);
        this.state = {
            hasMore: true,
            isLoading: false,
            sprites: [],
            tags: []
        };
        this.mounted = false;
        this.requestId = 0;
    }
    componentDidMount () {
        this.mounted = true;
        loadScratchSpriteTags()
            .then(tags => {
                if (!this.mounted) return;
                this.setState({tags});
            });
    }
    componentWillUnmount () {
        this.mounted = false;
    }
    handleItemSelect (item) {
        // Randomize position of library sprite
        randomizeSpritePosition(item);
        this.props.vm.addSprite(JSON.stringify(item)).then(() => {
            this.props.onActivateBlocksTab();
        });
    }
    handleRequestQuery (query) {
        const currentRequestId = this.requestId + 1;
        this.requestId = currentRequestId;
        const loadingState = {
            hasMore: true,
            isLoading: true
        };
        if (!query.append) {
            loadingState.sprites = [];
        }
        this.setState(loadingState);

        return loadScratchSprites(query)
            .then(({hasMore, records, response}) => {
                if (currentRequestId !== this.requestId) return response;

                const nextSprites = query.append ?
                    this.state.sprites.concat(records) :
                    records;
                this.setState({
                    hasMore,
                    isLoading: false,
                    sprites: nextSprites
                });
                return response;
            })
            .catch(() => {
                if (currentRequestId === this.requestId) {
                    this.setState({
                        hasMore: false,
                        isLoading: false
                    });
                }
                return null;
            });
    }
    render () {
        return (
            <LibraryComponent
                data={this.state.sprites}
                hasMore={this.state.hasMore}
                id="spriteLibrary"
                isLoading={this.state.isLoading}
                pageSize={SCRATCH_SPRITE_PAGE_SIZE}
                scopeFilterable
                tags={this.state.tags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
                onRequestQuery={this.handleRequestQuery}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(SpriteLibrary);
